var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSchoolFilled = function SvgSchoolFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "M5.241 12.642v3.482c0 1.2.6 2.32 1.599 2.983l1.607 1.07a6.416 6.416 0 0 0 7.105 0l1.607-1.07a3.583 3.583 0 0 0 1.599-2.983v-3.481l-4.097 2.276a5.484 5.484 0 0 1-5.322 0L5.24 12.642Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "M14.223 3.558a4.704 4.704 0 0 0-4.446 0L2.676 7.386a1.256 1.256 0 0 0 0 2.228l7.101 3.828a4.704 4.704 0 0 0 4.446 0l7.101-3.828a1.256 1.256 0 0 0 0-2.228l-7.101-3.828Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSchoolFilled);
export default ForwardRef;